import { render, staticRenderFns } from "./LogoPanel.vue?vue&type=template&id=776ff385&scoped=true"
import script from "./LogoPanel.vue?vue&type=script&lang=js"
export * from "./LogoPanel.vue?vue&type=script&lang=js"
import style0 from "./LogoPanel.vue?vue&type=style&index=0&id=776ff385&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776ff385",
  null
  
)

export default component.exports